const axios = require('axios');
module.exports.init = me => {
  me.sendMetadataOrder = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    const formData = new FormData();
    for (const key in data) {
      formData.append(key, data[key]);
    }
    me.globalheaders = {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    };
    axios.post(`${me.config.url}/order-meta-data/store`, formData, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
};